export const apiSignature = {
  CREATE_APPOINTMENI_API: "appointment/createAppointmentAPI",
  UPDATE_APPOINTMENT_API: "appointment/updateAppointmentAPI",
  GET_APPOINTMENI_API: "appointment/fetchAppointmentAPI",
  APPOINTMENI_TIME_BLOCK_API: "appointment/fetchAppointmentTimeBlockAPI",
  APPOINTMENT_TOTAL_COUNT_API: "appointment/fetchAppointmentCountAPI",
  SEND_PAYMENT_LINK_API:"appointment/sendPaymentLinkAPI",
  PAYMENT_TRANSACTION_API:"appointment/fetchPaymentTransactionAPI"
};
